<template>

  <nav class="container row">
    <div class="link">
      <router-link :to="{name: 'thisism'}">THISISM</router-link>
    </div>
    <div class="link">
      <router-link :to="{name: 'video-archives'}">VIDEO</router-link>
    </div>
    <div class="link"><a href="http://blog.livedoor.jp/thisism/" target="_blank">BLOG</a></div>
    <div class="link">
      <router-link :to="{name: 'more'}">&MORE</router-link>
    </div>
    <div class="link"><a href="mailto:thisismgml@gmail.com">CONTACT</a></div>
  </nav>

</template>

<script>
  export default {}
</script>

<style lang="scss" scoped>

  @font-face {
    font-family: hardcore_pen_regular;
    src: url('/static/font/hardcore_pen_regular.ttf');
  }

  @import "../style/common";

  a {
    text-decoration: none;
    &:link {
      color: $color_white;
    }
    &:visited {
      color: $color_white;
    }
  }

  nav {
    //color: $color_white;
    font-size: 2.5rem;
    margin-top: 2rem;
    margin-bottom: 2rem;
    text-align: center;
  }

  .link {
    //skeltonのcolumnの代替えでfloatをかける
    float: left;
    box-sizing: border-box;

    line-height: 3rem;
    text-align: center;

    height: 100%;
    width: 100%;

    &:hover {
      font-family: hardcore_pen_regular;
      font-size: 6rem;
    }

    a {
      display: block;
    }
  }

  /* Larger than phablet */
  @media (min-width: 550px) {

    nav {
      font-size: 2.5rem;
      height: 6rem;
      margin-top: 2rem;
      margin-bottom: 2rem;
    }

    .link {
      line-height: 6rem;

      &:hover {
        font-size: 6rem;
      }
    }

    .link {
      width: 20%; //skeltonだときっちり5分割ができないから

      &:hover {
        font-family: hardcore_pen_regular;
        font-size: 6rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Navigation.vue?79ddc168